import { floatify } from 'lib/maths/mathUtils'
import { createSelector } from 'reselect'
import getDynamicPaymentScheduleDepositAmount from './getDynamicPaymentScheduleDepositAmount'
import getServiceFeeForInitialDynamicPaymentSchedulePayment from './getDynamicPaymentSchedulePaymentServiceFee'

const getDynamicPaymentScheduleMerchantFeeEligibleAmount = createSelector(
  getDynamicPaymentScheduleDepositAmount,
  getServiceFeeForInitialDynamicPaymentSchedulePayment,
  (depositAmount, serviceFeeForInitialPayment): number => {
    return floatify(depositAmount - serviceFeeForInitialPayment)
  },
)

export default getDynamicPaymentScheduleMerchantFeeEligibleAmount
